/**
 * Titre affichable d'un CV noté, tiré du nom du fichier choisi : sans extension, soulignés remplacés
 * par des espaces. null si rien d'exploitable n'en reste (le serveur reçoit alors aucun titre).
 */
// Les formats que le sélecteur de CV accepte : « v1.2 » ou « Dupont.2024 » ne sont pas des extensions.
const EXTENSION = /\.(pdf|docx?|odt|rtf|txt|pages)$/i;

export function titreDepuisNom(nom: string | null | undefined): string | null {
  if (!nom) return null;
  const sansExtension = nom.trim().replace(EXTENSION, '');
  const titre = sansExtension.replace(/_+/g, ' ').replace(/\s+/g, ' ').trim();
  return titre || null;
}
